<div class="instances-container">
    <mat-card class="mat-elevation-z0 dashboard__menu instances-wrapper">
        <mat-card-title>Instances:</mat-card-title>
        <mat-form-field class="search-field" subscriptSizing="dynamic">
            <mat-label>Instance name</mat-label>
            <input matInput type="text" [ngModel]="searchValue" (input)="search($event.target.value)">
            <button *ngIf="searchValue" class="clear-search-button" matSuffix mat-icon-button aria-label="Clear"
                (click)="clearSearchValue()">
                <mat-icon class="clear-search-icon">close</mat-icon>
            </button>
        </mat-form-field>

        <mat-card-content class="instances">
            <mat-list class="instances-list">
                <mat-list-item *ngFor="let instance of foundInstances" (click)="pickInstance(instance)"
                    class="instances__item">
                    <div class="list-item-container">
                        <app-selected-indicator
                            [isSelected]="instance.Id == selectedInstance && !areTasksOpened"></app-selected-indicator>
                        <span style="cursor: pointer">{{instance.Name}} - {{instance.State?.toLowerCase()}}</span>
                    </div>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>

    <div class="totals-container">
        <mat-divider></mat-divider>
        <mat-card class="dashboard__menu">
            <mat-card-title>Totals:</mat-card-title>
            <mat-card-content class="instances" style="padding-top: 5px !important">
                <mat-list class="instances-list">
                    <mat-list-item class="instances__item">
                        <div class="list-item-container">
                            <app-selected-indicator [isSelected]="areTasksOpened"></app-selected-indicator>
                            <span class="totals-item" [routerLink]="['tasks']" (click)="selectTasks()">Tasks</span>
                        </div>
                    </mat-list-item>
                    <mat-list-item class="instances__item">
                        <div class="list-item-container">
                            <app-selected-indicator [isSelected]="areJobsOpened"></app-selected-indicator>
                            <span class="totals-item" [routerLink]="['jobs']" (click)="selectTasks()">Jobs
                                Overview</span>
                        </div>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>
    </div>

</div>

<mat-divider [vertical]="true"></mat-divider>

<router-outlet></router-outlet>

<app-spinner [showOverlay]="true" *ngIf="showSpinner"></app-spinner>